<template>
  <div class="presenter-view-container">
    <presenter :user="user" :projectName="project"/>
  </div>
</template>

<script>
import Presenter from '@/components/designer/Presenter.vue'
export default {
  name: 'PresenterView',
  components: {
    Presenter,
  },
  props: {
    user: {
      type: String
    },
    project: {
      type: String
    }
  },
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss" scoped>
</style>